export const ORG_TYPES = [
  { value: "business", label: "Business" },
  { value: "investor", label: "Investor" },
  { value: "lender", label: "Lender" },
  { value: "supplier", label: "Supplier" },
  { value: "contractor", label: "Contractor" },
  { value: "service_provider", label: "Service Provider" },
  { value: "nonprofit", label: "Nonprofit" },
  { value: "government", label: "Government Agency" },
  { value: "enterprise_buyer", label: "Enterprise Buyer" },
];

export const CERTIFICATIONS = [
  { value: "small_business", label: "Small Business" },
  { value: "minority_owned", label: "Minority-Owned" },
  { value: "women_owned", label: "Women-Owned" },
  { value: "veteran_owned", label: "Veteran-Owned" },
  { value: "8a_certified", label: "8(a) Certified" },
  { value: "mbe_certified", label: "MBE Certified" },
  { value: "wbe_certified", label: "WBE Certified" },
  { value: "iso_9001", label: "ISO 9001" },
  { value: "hubzone", label: "HUBZone" },
  { value: "sdvosb", label: "SDVOSB" },
];

export function orgLabel(v) {
  return ORG_TYPES.find((o) => o.value === v)?.label || v;
}
export function certLabel(v) {
  return CERTIFICATIONS.find((c) => c.value === v)?.label || v;
}
